import clsx from 'clsx';
import { memo } from 'react';

import { useTeamLinkRule } from '../../hooks/useLinkRule';
import type { TeamBadgeProps } from '../../TeamBadge';
import TeamBadge from '../../TeamBadge';

import { isNational, isRegions } from '@utilities/live';

export type TeamFlagProps = TeamBadgeProps & {
  teamLink?: boolean;
};

const Flag = ({
  team,
  className = '',
  competitionId = window.competitionId,
  phase = window.currentPhase,
  format = '70x70',
  size = 32,
  slot,
}: TeamBadgeProps) => {
  const isTeam = isNational(team) || isRegions(competitionId);

  return (
    <TeamBadge
      className={clsx({
        [className]: !!className,
        'team-flag': isTeam,
        'club-logo': !isTeam,
      })}
      format={format}
      slot={slot}
      size={size}
      team={team}
      competitionId={competitionId}
      phase={phase}
    />
  );
};

const LinkedFlag = (props: TeamFlagProps) => {
  const { team, competitionId, phase } = props;
  const teamUrl = useTeamLinkRule(team?.id, competitionId, false, phase);

  return (
    <a href={teamUrl} title={team?.internationalName}>
      <Flag {...props} />
    </a>
  );
};

const TeamFlag = (props: TeamFlagProps) => {
  const { teamLink } = props;
  return teamLink ? <LinkedFlag {...props} /> : <Flag {...props} />;
};

export default memo(TeamFlag);
